import { createSlice } from "@reduxjs/toolkit";
import { IEmailConfigurationSlice } from "../../../models/master/email";


const initialEmailConfigurationState: IEmailConfigurationSlice = {
  emailConfiguration:undefined,
  emailConfigurations:undefined,
};

const emailConfigurationSlice = createSlice({
  name: "emailConfiguration",
  initialState: initialEmailConfigurationState,
  reducers: {
    setEmailConfiguration: (state, action: { payload: any }) => {
      state.emailConfiguration = action.payload;
    }, 
    setEmailConfigurations: (state, action: { payload: any }) => {
      state.emailConfigurations = action.payload;
    },
    
  },
});

export const { setEmailConfiguration, setEmailConfigurations } =
emailConfigurationSlice.actions;

const emailConfigurationReducer = emailConfigurationSlice.reducer;

export type setEmailConfigurationState = ReturnType<typeof emailConfigurationReducer>;

export default emailConfigurationReducer;
